/* Tracking Event Report client data model
 * 
 */

import moment from "moment-timezone";

import makePropsEnumerable from "../utility/MakePropsEnumerable";

const mLogSvc = new WeakMap();

class TrackingEventReport {
    constructor(
        $log,
        eventId,
        eventReport,
        eventReportUpdateTime,
        eventHasStoredReport,
        eventPreFiledStatus
    )
    {
        if ($log != null) {
            mLogSvc.set(this, $log);
        }
        else {
            throw new Error("Tracking Event Report: Missing log service");
        }

        if (Number.isInteger(eventId))
        {
            this.trackingEventId = eventId;
        }
        else {
            throw new TypeError("Invalid or missing tracking event id.");
        }

        if ((eventReport != null) &&
            (angular.isString(eventReport)))
        {
            this.report = eventReport;
        }
        else {
            throw new TypeError("Invalid or missing tracking event report.");
        }

        let validTimeStamp = false;
        if (eventReportUpdateTime != null)
        {
            if (angular.isString(eventReportUpdateTime)) {
                let reportUpdateStamp = moment(new Date(eventReportUpdateTime));
                if (reportUpdateStamp.isValid()) {
                    this.reportUpdateTimeStamp = reportUpdateStamp;
                    validTimeStamp = true;
                }
            }
            else if (moment.isMoment(eventReportUpdateTime)) {
                if (eventReportUpdateTime.isValid()) {
                    this.reportUpdateTimeStamp = eventReportUpdateTime.clone();
                    validTimeStamp = true;
                }
            }
            else if (angular.isDate(eventReportUpdateTime)) {
                this.reportUpdateTimeStamp = moment(eventReportUpdateTime);
                validTimeStamp = true;
            }
        }

        if (!validTimeStamp) {
            throw new TypeError(
                "Invalid or missing tracking event report time stamp"
            );
        }

        this.serverHasReport = undefined;
        if ((eventHasStoredReport != null) &&
            (typeof(eventHasStoredReport) === "boolean"))
        {
            this.serverHasReport = eventHasStoredReport;
        }

        this.preFiledStatus = null;
        if ((eventPreFiledStatus != null) &&
            (angular.isDefined(eventPreFiledStatus.trackingStatusId)) &&
            (angular.isDefined(eventPreFiledStatus.trackingStatusName)))
        {
            this.preFiledStatus = eventPreFiledStatus;
        }

        this._decodedReport = undefined;
    }

    toString() {
        return "Tracking Report For " + String(this.trackingEventId);
    }

    valueOf() {
        return this.trackingEventId;
    }

    localUpdateStamp(timeZone) {
        let localUpdateStamp = this.reportUpdateTimeStamp.clone();
        localUpdateStamp.tz(timeZone);
        localUpdateStamp.local();
        return localUpdateStamp.toDate();
    }

    get decodedReport() {
        if (angular.isUndefined(this._decodedReport)) {
            mLogSvc.get(this).warn("No decoded report stored. Did you forget to do this?");
        }

        return this._decodedReport;
    }
    
    set decodedReport(decodedString) {
        mLogSvc.get(this).debug("Storing decoded report text.");
        this._decodedReport = decodedString;
    }
    
    static Create($log) {
        return (eventId, eventReport, eventReportUpdateTime, eventHasStoredReport, eventPreFiledStatus) => 
            new TrackingEventReport($log, eventId, eventReport, eventReportUpdateTime, eventHasStoredReport, eventPreFiledStatus);
    }
}

makePropsEnumerable(TrackingEventReport.prototype, [
    "localUpdateStamp",
    "decodedReport"
]);


export default TrackingEventReport;


//////////////////
// WEBPACK FOOTER
// ./src/models/TrackingEventReport.js
// module id = VbZN
// module chunks = 1